import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'thumbnail-button',
  templateUrl: './thumbnail-button.component.html',
  styleUrls: ['./thumbnail-button.component.scss']
})
export class ThumbnailButtonComponent implements OnInit {
  @Input() icon: string = "build";
  @Input() caption: string = "Caption";
  @Input() link: string[];
  @Input() program: string;

  @Output() click = new EventEmitter<any>();

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
  }

  async onClick(event) {
    event.stopPropagation();
    if(this.link) {
      await this.router.navigate(this.link, { relativeTo: this.route });
    }
    else {
      this.click.emit();
    }
  }

}
